import React from 'react';
import Button from '@primitives/Button';
import UploadComponent from '@cp/src/components/UploadComponent/UploadComponent';
import UploadSuccessComponent from '@cp/src/components/UploadComponent/UploadSuccessComponent';
import ImageUploadPlaceholder from '@cp/src/assets/icons/ImageUploadPlaceholder';

interface AddressProofUploadProps {
  proofOfSourceFile: File | null;
  setProofOfSourceFile: (file: File | null) => void;
  setProofOfSourceError: (error: string) => void;
  proofOfSourceError: string;
}

const AddressProofUpload: React.FC<AddressProofUploadProps> = ({
  proofOfSourceFile,
  setProofOfSourceFile,
  setProofOfSourceError,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  proofOfSourceError
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const UploadContent = (handleUploadClick: (e: React.ChangeEvent<any>) => void) => {
    return (
      <div className="upload-container-content flex flex-col items-center justify-center pt-4 w-full">
        <ImageUploadPlaceholder />
        <Button variant="text" onClick={handleUploadClick} className="text-nowrap !w-[100%]">
          Click to upload or drag and drop here
        </Button>
      </div>
    );
  };

  const handleCancel = () => {
    setProofOfSourceFile(null);
    setProofOfSourceError('');
  };

  return (
    <div>
      {proofOfSourceFile ? (
        <UploadSuccessComponent
          containerClassName="!m-0 w-full !ml-0"
          name={proofOfSourceFile.name}
          isInProgress={false}
          onCancel={handleCancel}
        />
      ) : (
        <UploadComponent
          setFile={setProofOfSourceFile}
          file={proofOfSourceFile}
          uploadContentContainer={UploadContent}
          isValidationInfoVisible={true}
          supportedFile=".jpeg,.png"
          MAX_FILE_SIZE_IN_MB={5}
          containerClassName="!m-0 w-full !p-0"
          textClassnameContainer=""
          setHasError={({ message }) => setProofOfSourceError(String(message))}
        />
      )}
    </div>
  );
};

export default AddressProofUpload;
